import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'ticketing-notice',
  name: '购票须知',
  icon: '须',
  group: '票务组件',
  description: '展示实名、退款、入园和客服说明。',
  defaultProps: {
    title: '购票须知',
    items: ['请携带购票证件入园', '退款以票种规则为准']
  }
}
